/**
 * Produktfinder an Ort und Stelle (F8, Rückmeldung Auftraggeber 06.10.2026, Entscheidung A141).
 *
 * Klick auf einen Finder-Knopf [data-pf-way] in einer Kachel (Startseite: home-range, home-accessories;
 * Products-Seite: category-series, home-accessories) öffnet genau diesen Weg direkt UNTER der Kachel,
 * statt zum Gesamt-Finder zu springen.
 *
 * Grundsatz: Es gibt weiterhin genau EINE Finder-Instanz je Seite (assets/product-finder.js, unverändert).
 * Dieses Skript verschiebt nur deren Container (section[data-product-finder]) in ein Aufklapp-Feld unter der
 * Kachel und beim Schließen wieder zurück. Fragen, Antworten, Ergebnisse, Preise und Analytics laufen damit
 * über exakt denselben Code wie oben:
 *   - Dieses Skript hört in der Capture-Phase, verschiebt den Container und lässt das Ereignis weiterlaufen.
 *   - Danach behandelt der vorhandene Listener in product-finder.js den Klick wie bisher
 *     (goWay(n) + finder_start mit finder_entry "home_tile", Scroll zum Finder-Anfang).
 * An der alten Stelle steht solange eine stille Kopie der Startansicht (Wege-Karten). Ein Klick darauf holt den
 * Finder zurück und öffnet den Weg dort, über den echten Wege-Knopf (gleicher Pfad wie bisher).
 *
 * Ohne JavaScript bleibt alles wie heute: die Knöpfe sind Links auf #product-finder.
 * Eigener Gültigkeitsbereich (IIFE), kein globaler Name.
 */
(function () {
  "use strict";

  var PANEL_ID = "pf-inline-panel";
  var DUR = 320; // ms Aufklappen/Zuklappen
  var root, ghost, panel, closeBtn, titleEl, trigger, hostTile, clipped = [], busy = false;

  // G2/H1 (07.10.2026): Kachelname für die Überschrift „Finder: <Kachelname>“ und Lage der Kerbe unter der Kachel.
  function tileName(tile) {
    var h = tile.querySelector(".h58-tile__title, .rg-pg-head h2, .rg-pg-head h3, h2, h3");
    return h ? h.textContent.replace(/\s+/g, " ").trim() : "";
  }
  function placeNotch() {
    if (!panel || !hostTile || !panel.parentNode) return;
    var pr = panel.getBoundingClientRect(), tr = hostTile.getBoundingClientRect();
    var x = Math.round(tr.left + tr.width / 2 - pr.left);
    panel.style.setProperty("--pfi-x", Math.max(24, Math.min(pr.width - 24, x)) + "px");
  }
  function setHost(tile) {
    Array.prototype.forEach.call(document.querySelectorAll(".pfi-host"), function (x) { if (x !== tile) x.classList.remove("pfi-host"); });
    if (tile) tile.classList.add("pfi-host");
  }
  function setTitle(tile) {
    var name = tile ? tileName(tile) : "";
    var head = root.querySelector(".pfn-head");
    if (!name || !head) { if (titleEl && titleEl.parentNode) titleEl.parentNode.removeChild(titleEl); return; }
    if (!titleEl) { titleEl = document.createElement("p"); titleEl.className = "pfi-title"; }
    var pre = root.getAttribute("data-pf-inline-prefix") || "Finder";
    titleEl.textContent = "";
    var b = document.createElement("b"); b.textContent = pre + ": ";
    titleEl.appendChild(b);
    titleEl.appendChild(document.createTextNode(name));
    if (titleEl.parentNode !== head) head.insertBefore(titleEl, head.firstChild);
    panel.setAttribute("aria-label", pre + ": " + name);
  }

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }
  function raf(fn) { (window.requestAnimationFrame || setTimeout)(fn); }

  // Nur Knöpfe in Kacheln bzw. Bereichsköpfen; alles andere springt wie bisher zum Finder.
  // AUFTRAG-76 (2.3): Kacheln der Produktübersicht tragen das Datenattribut data-pf-tile (statt einer geborgten Klasse).
  function tileOf(t) {
    return t.closest(".h58-tile") || t.closest(".rg-pg-head") || t.closest("[data-pf-tile]");
  }

  // Einfügepunkt: im Kachelraster nach der letzten Kachel derselben sichtbaren Zeile, sonst nach dem Block.
  function anchorAfter(tile) {
    var grid = tile.parentElement;
    if (!tile.classList.contains("h58-tile") || !grid) return tile;
    // offsetTop statt getBoundingClientRect: die Einblend-Animation (.rv) verschiebt Kacheln per transform.
    var top = tile.offsetTop, last = tile;
    Array.prototype.forEach.call(grid.children, function (c) {
      if (c === panel || !c.classList.contains("h58-tile")) return;
      if (Math.abs(c.offsetTop - top) < 4 && (last.compareDocumentPosition(c) & Node.DOCUMENT_POSITION_FOLLOWING)) last = c;
    });
    return last;
  }

  // Ein Element bleibt optisch an seiner Stelle, während darüber DOM getauscht wird (kein Layoutsprung).
  function keepInPlace(el, change) {
    // Ausgleich sofort, nicht weich: scroll-behavior: smooth am html würde den Sprung sonst sichtbar nachziehen.
    var de = document.documentElement, prevA = de.style.overflowAnchor, prevB = de.style.scrollBehavior;
    de.style.overflowAnchor = "none";
    de.style.scrollBehavior = "auto";
    var before = el ? el.getBoundingClientRect().top : 0;
    change();
    if (el) {
      var diff = el.getBoundingClientRect().top - before;
      if (Math.abs(diff) > 0.5) window.scrollBy(0, diff);
    }
    de.style.overflowAnchor = prevA;
    de.style.scrollBehavior = prevB;
  }

  // Die Sektionen der Kacheln schneiden mit overflow: hidden ab; das macht sie zum Scroll-Container und hebt die
  // klebende Ergebnis-Spalte auf. Solange der Finder dort steht: overflow: clip (schneidet gleich ab, klebt aber).
  function unclip() {
    clipped.forEach(function (c) { c.el.style.overflow = c.v; });
    clipped = [];
  }
  function clipAncestors() {
    unclip();
    for (var n = panel.parentElement; n && n !== document.body; n = n.parentElement) {
      var cs = getComputedStyle(n);
      if (cs.overflowY === "hidden" || cs.overflowX === "hidden") {
        clipped.push({ el: n, v: n.style.overflow });
        n.style.overflow = "clip";
      }
    }
  }

  // Unterkante aller oben klebenden Leisten (Kopfzeile, Sprungleiste der Products-Seite), gemessen beim Öffnen.
  // Der Finder-Anfang soll darunter stehen, nicht dahinter (Rückfall: 96 px aus product-finder.css).
  function coverBottom() {
    var maxB = 0, x = Math.round(window.innerWidth / 2);
    for (var y = 0; y <= 320; y += 8) {
      var n = document.elementFromPoint(x, y);
      while (n && n !== document.body && n !== document.documentElement) {
        var pos = getComputedStyle(n).position;
        if (pos === "fixed" || pos === "sticky") { maxB = Math.max(maxB, n.getBoundingClientRect().bottom); break; }
        n = n.parentElement;
      }
    }
    return Math.round(maxB);
  }

  // Kachelraster: Die Zeilen sind teils "1fr" (gleich hohe Kacheln). Ein Feld im Raster würde alle fr-Zeilen auf seine
  // Höhe ziehen. Deshalb werden die Zeilen beim Öffnen auf ihre gemessenen Höhen festgeschrieben und das Feld bekommt
  // eine eigene Zeile "auto" direkt unter der Kachelzeile. Die Kacheln behalten so exakt ihre Größe.
  var gridSaved = null;
  function restoreGrid() {
    if (!gridSaved) return;
    gridSaved.el.style.gridTemplateRows = gridSaved.rows;
    gridSaved.el.style.gridAutoRows = gridSaved.auto;
    gridSaved = null;
    if (panel) panel.style.gridRow = "";
  }
  function fitGrid() {
    restoreGrid();
    var grid = panel.parentElement, prev = panel.previousElementSibling;
    if (!grid || !prev || !prev.classList.contains("h58-tile")) return;
    var cs = getComputedStyle(grid);
    if (cs.display.indexOf("grid") === -1) return;
    panel.style.display = "none";
    var tracks = getComputedStyle(grid).gridTemplateRows.split(/\s+/).filter(function (t) { return /px$/.test(t); });
    var gap = parseFloat(cs.rowGap) || 0, first = grid.querySelector(".h58-tile");
    var end = prev.offsetTop + prev.offsetHeight - first.offsetTop, pos = 0, k = -1;
    for (var i = 0; i < tracks.length; i++) {
      pos += parseFloat(tracks[i]);
      if (Math.abs(pos - end) < 2) { k = i; break; }
      pos += gap;
    }
    panel.style.display = "";
    if (k < 0) return;
    gridSaved = { el: grid, rows: grid.style.gridTemplateRows, auto: grid.style.gridAutoRows };
    grid.style.gridTemplateRows = tracks.slice(0, k + 1).concat(["auto"], tracks.slice(k + 1)).join(" ");
    grid.style.gridAutoRows = "auto";
    panel.style.gridRow = String(k + 2);
  }

  function buildGhost() {
    var g = root.cloneNode(true);
    g.removeAttribute("data-product-finder");
    g.removeAttribute("id");
    g.removeAttribute("aria-busy");
    g.setAttribute("data-way", "0");
    g.setAttribute("data-pf-ghost", "");
    g.__pfInit = true;
    var cfg = g.querySelector("[data-pf-config]");
    if (cfg) cfg.parentNode.removeChild(cfg);
    var app = g.querySelector("[data-pf-app]");
    if (app) app.parentNode.removeChild(app);
    Array.prototype.forEach.call(g.querySelectorAll("[id]"), function (x) { x.removeAttribute("id"); });
    Array.prototype.forEach.call(g.querySelectorAll(".pfn-way"), function (a) { a.classList.remove("on"); a.removeAttribute("aria-current"); });
    Array.prototype.forEach.call(g.querySelectorAll(".pfi-close"), function (x) { x.parentNode.removeChild(x); });
    // Für Screenreader verborgen und nicht per Tab erreichbar (Projektleiter 06.10.). Kein inert: die Maus soll den
    // Finder über die Kopie weiterhin nach oben zurückholen können.
    g.setAttribute("aria-hidden", "true");
    Array.prototype.forEach.call(g.querySelectorAll("a, button, [tabindex]"), function (x) { x.setAttribute("tabindex", "-1"); });
    return g;
  }

  function buildPanel() {
    panel = document.createElement("div");
    panel.className = "pfi";
    panel.id = PANEL_ID;
    panel.setAttribute("role", "region");
    var h = document.querySelector("[data-pf-band] h2, #product-finder h2, .pfn-h2");
    panel.setAttribute("aria-label", h ? h.textContent.trim() : "Product finder");
    panel.addEventListener("keydown", function (e) {
      if (e.key === "Escape" || e.key === "Esc") { e.preventDefault(); close(true); }
    });
  }

  function buildClose() {
    closeBtn = document.createElement("button");
    closeBtn.type = "button";
    closeBtn.className = "pfn-reset pfi-close";
    var label = root.getAttribute("data-pf-close") || "Close";
    closeBtn.innerHTML = '<span></span><svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true" focusable="false"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="2" stroke-linecap="square"/></svg>';
    closeBtn.firstChild.textContent = label;
    closeBtn.addEventListener("click", function () { close(true); });
  }

  function setExpanded(t, on) {
    if (!t) return;
    t.setAttribute("aria-expanded", on ? "true" : "false");
    if (on) t.setAttribute("aria-controls", PANEL_ID); else t.removeAttribute("aria-controls");
  }

  function animateOpen() {
    if (reducedMotion() || !panel.animate) return;
    panel.style.overflow = "hidden";
    var h = panel.scrollHeight;
    var a = panel.animate([{ height: "0px", opacity: 0 }, { height: h + "px", opacity: 1 }], { duration: DUR, easing: "cubic-bezier(.2,.7,.2,1)" });
    a.onfinish = a.oncancel = function () { panel.style.overflow = ""; };
  }

  function focusFinder() {
    // Fokus auf die erste Antwort des Weges; sonst auf den Finder selbst.
    raf(function () {
      var first = root.querySelector("[data-pf-app] .pfn-left button[data-a], [data-pf-app] button[data-a]");
      if (first) first.focus({ preventScroll: true });
      else { root.setAttribute("tabindex", "-1"); root.focus({ preventScroll: true }); }
    });
  }

  // Öffnen bzw. Umhängen unter die Kachel des Knopfes t. Das Klickereignis läuft danach weiter zu product-finder.js.
  function open(t, tile) {
    if (!panel) buildPanel();
    if (!closeBtn) buildClose();
    var wasOpen = !!(panel.parentNode);
    if (trigger && trigger !== t) setExpanded(trigger, false);
    trigger = t; hostTile = tile;
    keepInPlace(tile, function () {
      if (!ghost) { ghost = buildGhost(); root.parentNode.insertBefore(ghost, root); }
      restoreGrid();
      var after = anchorAfter(tile);
      after.parentNode.insertBefore(panel, after.nextSibling);
      if (root.parentNode !== panel) panel.appendChild(root);
      fitGrid();
    });
    root.classList.add("pfn--inline");
    root.style.scrollMarginTop = Math.max(96, coverBottom() + 16) + "px";
    var head = root.querySelector(".pfn-head");
    if (head && closeBtn.parentNode !== head) head.appendChild(closeBtn);
    setHost(tile);
    setTitle(tile);
    placeNotch();
    clipAncestors();
    setExpanded(t, true);
    if (!wasOpen) animateOpen();
    focusFinder();
  }

  // Zurück an die alte Stelle. back = sanft zur Kachel zurückscrollen und Fokus auf den Kachel-Knopf.
  function close(back, done) {
    if (!panel || !panel.parentNode || busy) return;
    busy = true;
    var t = trigger, tile = hostTile;
    var finish = function () {
      keepInPlace(tile, function () {
        if (closeBtn.parentNode) closeBtn.parentNode.removeChild(closeBtn);
        if (titleEl && titleEl.parentNode) titleEl.parentNode.removeChild(titleEl);
        setHost(null);
        root.classList.remove("pfn--inline");
        root.style.scrollMarginTop = "";
        root.removeAttribute("tabindex");
        if (ghost && ghost.parentNode) ghost.parentNode.replaceChild(root, ghost);
        ghost = null;
        restoreGrid();
        if (panel.parentNode) panel.parentNode.removeChild(panel);
      });
      panel.style.height = ""; panel.style.overflow = "";
      unclip();
      setExpanded(t, false);
      trigger = null; hostTile = null; busy = false;
      if (back && tile) {
        if (t) t.focus({ preventScroll: true });
        var r = tile.getBoundingClientRect(), off = coverBottom();
        if (r.top < off + 8 || r.top > window.innerHeight * 0.6) {
          window.scrollTo({ top: Math.max(0, window.pageYOffset + r.top - off - 24), behavior: reducedMotion() ? "auto" : "smooth" });
        }
      }
      if (done) done();
    };
    if (reducedMotion() || !panel.animate) { finish(); return; }
    // Zuklappen: das Feld schrumpft auf 0. Steht die Kachel darüber, bleibt sie ruhig; der Inhalt darunter rückt nach.
    var h = panel.offsetHeight;
    panel.style.overflow = "hidden";
    var a = panel.animate([{ height: h + "px", opacity: 1 }, { height: "0px", opacity: 0 }], { duration: DUR, easing: "cubic-bezier(.4,0,.2,1)" });
    panel.style.height = "0px";
    a.onfinish = a.oncancel = finish;
  }

  function onTriggerClick(e) {
    var t = e.target && e.target.closest ? e.target.closest("[data-pf-way]") : null;
    if (!t || t.closest("[data-product-finder]") || t.closest("[data-pf-ghost]")) return;
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var n = Number(t.getAttribute("data-pf-way"));
    if (!(n >= 1 && n <= 6) || Math.floor(n) !== n) return;
    var tile = tileOf(t);
    if (!tile || !root || !root.__pfInit) return; // kein Finder initialisiert: Verhalten wie bisher
    // Derselbe Knopf bei offenem Feld: zuklappen (Aufklapp-Knopf), product-finder.js nicht erneut auslösen.
    if (trigger === t && panel && panel.parentNode && !busy) {
      e.preventDefault(); e.stopPropagation();
      close(true);
      return;
    }
    if (busy) { e.preventDefault(); e.stopPropagation(); return; }
    open(t, tile);
    // Ereignis läuft weiter: product-finder.js wählt Weg n (goWay, finder_start "home_tile") und scrollt zum Finder.
  }

  // Klick in der stillen Kopie oben: Finder zurückholen, dann den echten Wege-Knopf auslösen (gleicher Pfad wie bisher).
  function onGhostClick(e) {
    var g = e.target && e.target.closest ? e.target.closest("[data-pf-ghost]") : null;
    if (!g) return;
    var el = e.target.closest("[data-a]");
    if (!el) return;
    e.preventDefault(); e.stopPropagation();
    var a = el.getAttribute("data-a"), v = el.getAttribute("data-v");
    close(false, function () {
      var real = root.querySelector('[data-a="' + a + '"][data-v="' + v + '"]');
      if (real) real.click();
    });
  }

  function onResize() {
    if (!panel || !panel.parentNode || !hostTile || busy) return;
    keepInPlace(hostTile, function () {
      restoreGrid();
      var after = anchorAfter(hostTile);
      if (panel.previousElementSibling !== after) after.parentNode.insertBefore(panel, after.nextSibling);
      fitGrid();
    });
    placeNotch();
  }

  function init() {
    root = document.querySelector("[data-product-finder]");
    if (!root) return;
    // Kachel-Knöpfe als Aufklapp-Knöpfe kennzeichnen (nur mit JavaScript; ohne bleibt es ein Sprunglink)
    Array.prototype.forEach.call(document.querySelectorAll("[data-pf-way]"), function (t) {
      if (!t.closest("[data-product-finder]") && tileOf(t)) t.setAttribute("aria-expanded", "false");
    });
    document.addEventListener("click", onTriggerClick, true);
    document.addEventListener("click", onGhostClick, true);
    var rt;
    window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(onResize, 150); });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
